import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { OrderItem } from '../../components/order-item/order-item';
import { AsyncPipe, isPlatformBrowser, NgClass, NgFor, NgIf } from '@angular/common';
import { OrderInfo } from '../../components/order-info/order-info';
import { OrderPage, OrderService } from '../../service/order-service';
import { Order, OrderStatus } from '../../models/order';
import { Observable } from 'rxjs';
import { ItemsLoading } from '../../components/items-loading/items-loading';
import { ItemsNotFound } from '../../components/items-not-found/items-not-found';
import { faBoxOpen } from '@fortawesome/free-solid-svg-icons';
import { Analytics, logEvent } from '@angular/fire/analytics';
@Component({
  selector: 'app-orders',
  imports: [OrderItem, OrderInfo, AsyncPipe, ItemsLoading, ItemsNotFound, NgIf],

  templateUrl: './orders.html',
  styleUrl: './orders.scss'
})
export class Orders implements OnInit {
  private orderService = inject(OrderService)
  protected orders$: Observable<Order[]> | undefined
  protected paginationInfo$: Observable<any> | undefined
  private analytics = inject(Analytics);
  private platformId = inject(PLATFORM_ID);
  faBoxOpen = faBoxOpen

  protected filters: OrderStatus = OrderStatus.ALL;

  ngOnInit(): void {
    if(isPlatformBrowser(this.platformId)){
      logEvent(this.analytics, 'orders_page_view', { page_path: '/orders' });
    }
    this.loadPage();
  }

  onFilterSelected(status: string) {
    this.filters = status as OrderStatus;
    this.loadPage();
  }

  loadPage() {
    this.orders$ = this.orderService.getProductObservable(this.filters);
    this.paginationInfo$ = this.orderService.getPaginationInfoObservable()
  }

  onPageChange(event: Event, page: number): void {
    event.preventDefault();
    // this.orderService.goToPage(page);
    // this.orders$ = this.orderService.getProductObservable(this.filters);
  }

  onPrevious(event: Event): void {
    event.preventDefault();
    this.orders$ = this.orderService.previousPage(this.filters);
  }

  onNext(event: Event): void {
    event.preventDefault();
    this.orders$ = this.orderService.nextPage(this.filters);
  }

  getPageNumbers(currentPage: number, pageCount: number): number[] {
    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(pageCount, startPage + maxVisiblePages - 1);

    // Adjust if we're at the start or end
    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  onOrderCancelled() {
    this.loadPage();
  }
}
